<section class="subscription-health" [attr.data-tone]="subscriptionMeta.tone">
    <div>
        <p class="subscription-health-kicker">Stato abbonamento</p>
        <h3 class="subscription-health-title">{{ subscriptionMeta.label }}</h3>
        <p class="subscription-health-copy" *ngIf="hasPlan">
            Piano {{ company.service.name }}
            <ng-container *ngIf="company.billedPeriod === 'yearly'"> · annuale</ng-container>
            <ng-container *ngIf="company.billedPeriod === 'monthly'"> · mensile</ng-container>
            <ng-container *ngIf="stripePeriodEndLabel"> · periodo fino al {{ stripePeriodEndLabel }}</ng-container>
        </p>
        <p class="subscription-health-copy" *ngIf="!hasPlan">
            Questa società non ha un piano valido.
            <ng-container *ngIf="userIsSuperAdmin"> Puoi assegnarne uno nuovo da qui.</ng-container>
        </p>
    </div>
    <div class="subscription-health-actions" *ngIf="userIsSuperAdmin && !changingPlan">
        <button type="button"
                class="btn btn-primary"
                (click)="startChangePlan()">
            {{ hasPlan ? 'Cambia abbonamento' : 'Assegna abbonamento' }}
        </button>
        <button type="button"
                class="btn welldone-btn-light"
                *ngIf="canRetryPayment"
                [disabled]="retryLoading"
                (click)="retryPayment()">
            {{ retryLoading ? 'Tentativo in corso...' : 'Riprova pagamento' }}
        </button>
    </div>
</section>

<div class="subscription-change" *ngIf="userIsSuperAdmin && changingPlan">
    <ng-container *ngIf="!showStripeCheckout">
        <div class="plan-list-card">
            <div class="plan-list-header">
                <div>
                    <h3 class="plan-list-title">{{ hasPlan ? 'Scegli un nuovo piano' : 'Scegli il piano' }}</h3>
                    <p class="plan-list-subtitle">Include anche gli abbonamenti nascosti. Il pagamento è su Stripe.</p>
                </div>
                <div class="billing-toggle">
                    <button type="button" class="billing-pill" [class.active]="billingPeriod === 'monthly'" (click)="billingPeriod = 'monthly'">Mensile</button>
                    <button type="button" class="billing-pill" [class.active]="billingPeriod === 'yearly'" (click)="billingPeriod = 'yearly'">Annuale</button>
                </div>
            </div>

            <div class="plan-list" *ngIf="services.length; else noPlans">
                <button type="button"
                        class="plan-list-row"
                        *ngFor="let service of services"
                        [class.is-selected]="setCheckbox(service)"
                        (click)="selectPlan(service)">
                    <span class="plan-list-radio" aria-hidden="true"></span>
                    <span class="plan-list-main">
                        <span class="plan-list-name">{{ service.name }}</span>
                        <span class="plan-list-meta">
                            <span class="badge badge-warning" *ngIf="isServiceHidden(service)">Nascosto</span>
                            <span class="badge badge-success" *ngIf="isCurrentCompanyPlan(service)">Piano attuale</span>
                        </span>
                    </span>
                    <span class="plan-list-price">
                        {{ getDisplayedPrice(service) | number:'1.2-2' }}€
                        <span class="plan-list-period">{{ billingPeriod === 'monthly' ? '/mese' : '/' + getServiceRecurrencyMonths(service) + ' mesi' }}</span>
                    </span>
                </button>
            </div>
            <ng-template #noPlans>
                <p class="mb-0 text-muted">Nessun abbonamento disponibile.</p>
            </ng-template>
        </div>
        <div class="subscription-health-actions mt-3">
            <button type="button" class="btn btn-primary" [disabled]="servicesSelected.length === 0" (click)="goToPayment()">
                Continua al pagamento
            </button>
            <button type="button" class="btn welldone-btn-light" (click)="cancelChangePlan()">Annulla</button>
        </div>
    </ng-container>

    <ng-container *ngIf="showStripeCheckout && servicesSelected.length">
        <div class="subscription-card">
            <div class="subscription-card-inner">
                <h4 class="subscription-plan-name">Completa il pagamento</h4>
                <app-stripe-embedded-checkout
                    [planId]="servicesSelected[0].id"
                    [billingPeriod]="billingPeriod"
                    [companyId]="companyId"
                    [email]="checkoutEmail"
                    [useOldCompanyCheckout]="true"
                    [replaceExisting]="replaceExistingPlan"
                    [treatExistingServiceAsSuccess]="false"
                    (paymentCompleted)="onPlanCheckoutCompleted()">
                </app-stripe-embedded-checkout>
                <div class="mt-3">
                    <button type="button" class="btn welldone-btn-light" (click)="backToPlanSelection()">Indietro</button>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ng-container *ngIf="hasPlan">
    <div class="subscription-card">
        <div class="subscription-card-inner">
            <div class="subscription-header">
                <div>
                    <h4 class="subscription-plan-name">{{ company.service.name }}</h4>
                    <span class="subscription-status"
                          [class.active]="subscriptionMeta.key === 'active'"
                          [class.warning]="subscriptionMeta.tone === 'warning'"
                          [class.danger]="subscriptionMeta.tone === 'danger'">
                        {{ subscriptionMeta.label }}
                    </span>
                </div>
                <div class="subscription-billing-label">
                    {{ getCompanySubscriptionBillingTitle() }}
                </div>
            </div>

            <div class="subscription-price">
                <div class="subscription-price-main">
                    <span class="amount">{{ getCompanySubscriptionDisplayPrice() }}€</span>
                    <span class="period">{{ getCompanySubscriptionPeriodSuffix() }}</span>
                </div>
            </div>

            <div class="d-flex flex-wrap gap-3 mt-2"
                 *ngIf="company.service.customFeeRate != null || company.service.monthCount != null">
                <span *ngIf="company.service.customFeeRate != null" class="badge bg-secondary">
                    Commissione: {{ company.service.customFeeRate * 100 }}%
                </span>
                <span *ngIf="company.service.monthCount != null" class="badge bg-secondary">
                    Durata: {{ company.service.monthCount }} mesi
                </span>
            </div>

            <div class="subscription-features" *ngIf="company.service.features?.length">
                <div class="subscription-features-title">Funzionalità incluse</div>
                <ul class="subscription-features-list">
                    <li *ngFor="let feature of company.service.features">
                        {{ feature.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="subscription-card">
        <div class="subscription-card-inner">
            <div class="subscription-header">
                <div>
                    <h4 class="subscription-plan-name">Prossima fattura da pagare</h4>
                    <span *ngIf="currentInvoice" class="subscription-status"
                          [class.active]="currentInvoice.status === 'paid'"
                          [class.subscription-status-upcoming]="currentInvoice.status === 'draft' || currentInvoice.status === 'upcoming'">
                        {{ currentInvoice.status === 'paid' ? 'Pagata' : (currentInvoice.status === 'draft' || currentInvoice.status === 'upcoming' ? 'Prossimo canone' : currentInvoice.status) }}
                    </span>
                </div>
                <div class="subscription-billing-label" *ngIf="currentInvoice">
                    <ng-container *ngIf="!isCompanySubscriptionYearly(); else nextInvoiceYearlyLabel">Canone mensile + commissioni</ng-container>
                    <ng-template #nextInvoiceYearlyLabel>Commissioni sul transato (fattura)</ng-template>
                </div>
            </div>

            <ng-container *ngIf="currentInvoice">
                <div class="subscription-price">
                    <div class="subscription-price-main">
                        <ng-container *ngIf="!isCompanySubscriptionYearly() && getNextInvoiceMonthlyCanoneEuros() != null && getNextInvoiceEstimatedFeeEuros() != null; else nextInvoiceTotalFallback">
                            <span class="amount">
                                {{ getNextInvoiceMonthlyCanoneEuros() | number:'1.2-2' }} € + {{ getNextInvoiceEstimatedFeeEuros() | number:'1.2-2' }} € di commissioni questo mese
                            </span>
                        </ng-container>
                        <ng-template #nextInvoiceTotalFallback>
                            <span class="amount">{{ (getNextInvoiceTotalEuros() ?? 0) | number:'1.2-2' }}</span>
                            <span class="period">{{ (currentInvoice.currency || 'eur') | uppercase }}</span>
                            <span *ngIf="isCompanySubscriptionYearly()" class="small text-muted d-block mt-2">Importo delle commissioni sul transato per questo periodo (il canone annuale è fatturato separatamente).</span>
                        </ng-template>
                    </div>
                </div>
                <div class="subscription-features" *ngIf="currentInvoice.invoice_pdf || currentInvoice.hosted_invoice_url">
                    <div class="subscription-features-title">Link</div>
                    <ul class="subscription-features-list">
                        <li *ngIf="currentInvoice.invoice_pdf">
                            <a [href]="currentInvoice.invoice_pdf" target="_blank" rel="noopener noreferrer" class="text-decoration-none text-dark">Scarica PDF</a>
                        </li>
                        <li *ngIf="currentInvoice.hosted_invoice_url">
                            <a [href]="currentInvoice.hosted_invoice_url" target="_blank" rel="noopener noreferrer" class="text-decoration-none text-dark">Visualizza online</a>
                        </li>
                    </ul>
                </div>
            </ng-container>

            <div *ngIf="company.service.customFeeRate != null" class="mt-3">
                <p class="small text-muted mb-0" style="max-width: 40rem;">
                    <strong>Commissione sulle transazioni (piano personalizzato):</strong>
                    {{ company.service.customFeeRate * 100 }}% sul valore delle operazioni;
                    viene conteggiata sul traffico del periodo. Non è l’importo del canone sopra.
                </p>
            </div>
            <div *ngIf="company.service.customFeeRate == null" class="mt-3">
                <p class="small text-muted mb-2" style="max-width: 40rem;">
                    <strong>Commissione sulle transazioni (graduale standard):</strong>
                    percentuali sul transato per fascia di iscrizioni annue, come in fase di registrazione.
                </p>
                <div class="subscription-features-title">Fasce</div>
                <ul class="list-unstyled small text-muted mb-0">
                    <li *ngFor="let tier of defaultTransactionTariffTiers"
                        class="d-flex flex-wrap justify-content-between gap-2 py-2 border-bottom border-light">
                        <span>{{ tier.range }}</span>
                        <span class="fw-semibold text-nowrap">{{ tier.rate }}</span>
                    </li>
                </ul>
            </div>

            <p *ngIf="!currentInvoice" class="mb-0 text-muted mt-3">Nessuna anteprima fattura disponibile.</p>
        </div>
    </div>
</ng-container>

<div class="subscription-card">
    <div class="subscription-card-inner">
        <div class="subscription-header">
            <div>
                <h4 class="subscription-plan-name">Metodo di pagamento</h4>
                <span *ngIf="currentCardDetails?.card_details?.card" class="subscription-status active">Attivo</span>
            </div>
            <div class="subscription-billing-label" *ngIf="currentCardDetails?.card_details?.card">Carta attuale</div>
        </div>

        <ng-container *ngIf="currentCardDetails?.card_details?.card">
            <div class="subscription-price">
                <div class="subscription-price-main">
                    <span class="amount text-capitalize">{{ currentCardDetails.card_details.card.display_brand || currentCardDetails.card_details.card.brand || 'Carta' }} •••• {{ currentCardDetails.card_details.card.last4 }}</span>
                    <span class="period" *ngIf="currentCardDetails.card_details.card.exp_month && currentCardDetails.card_details.card.exp_year">
                        Scadenza {{ currentCardDetails.card_details.card.exp_month }}/{{ currentCardDetails.card_details.card.exp_year }}
                    </span>
                </div>
                <div class="subscription-price-annual" *ngIf="currentCardDetails.card_details.billing_details?.name || currentCardDetails.card_details.billing_details?.email">
                    {{ currentCardDetails.card_details.billing_details?.name }}{{ currentCardDetails.card_details.billing_details?.name && currentCardDetails.card_details.billing_details?.email ? ' · ' : '' }}{{ currentCardDetails.card_details.billing_details?.email }}
                </div>
            </div>
        </ng-container>
        <div *ngIf="!currentCardDetails?.card_details?.card" class="subscription-price">
            <p class="mb-0 text-muted">Nessuna carta registrata.</p>
        </div>
        <div *ngIf="canEditPaymentMethod" class="mt-2">
            <button type="button" class="btn welldone-btn-light" (click)="updatePayment.emit()">
                Aggiorna metodo di pagamento
            </button>
        </div>
    </div>
</div>
